var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11_2146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.55912 24H9.29054C9.81399 24 10.2349 23.5758 10.2349 23.0484V21.4255C11.6186 21.219 12.8266 20.7801 13.8515 20.1051C15.4658 19.0318 16.2931 17.5528 16.3297 15.6607C16.3516 14.4804 16.0295 13.4772 15.356 12.6547C14.2615 11.3379 12.552 10.5154 10.2349 10.1909V6.90825C10.6413 7.10005 11.0366 7.36192 11.4136 7.69018C11.6479 7.88566 11.9151 7.98525 12.2226 7.98525C12.4715 7.98525 12.8119 7.81189 12.8119 7.81189L12.8192 7.80821L14.7593 6.58368C15.0229 6.41402 15.1583 6.20009 15.1656 5.93822C15.1693 5.72798 15.0851 5.54357 14.913 5.38497C13.7014 3.99816 12.1421 3.13877 10.2386 2.80313V0.951591C10.2386 0.424159 9.81399 0 9.2942 0H7.56279C7.03934 0 6.61838 0.427847 6.61838 0.951591V2.7515C5.72156 2.8769 4.91259 3.10558 4.19147 3.43753C1.8634 4.50715 0.721331 6.10788 0.761596 8.22868C0.779899 9.27248 1.09104 10.1982 1.69502 10.9986C2.70898 12.367 4.35254 13.2227 6.62204 13.5768V17.6782C5.64103 17.3278 4.71492 16.6787 3.84007 15.7234C3.64972 15.4726 3.39349 15.3472 3.07503 15.3472C2.89932 15.3472 2.5589 15.4984 2.5589 15.4984L2.55524 15.5021L0.79088 16.5459C0.476078 16.7229 0.329658 16.9553 0.333319 17.243C0.336979 17.4311 0.406529 17.597 0.541967 17.7483C1.00319 18.3937 1.61815 19.0134 2.39051 19.6035C3.63874 20.5735 5.04803 21.1747 6.61472 21.4255V23.0447C6.61472 23.5758 7.03567 24 7.55912 24ZM10.2349 14.0194C11.1684 14.3181 11.6406 14.864 11.6369 15.6717C11.6296 16.4242 11.2892 17.0032 10.6156 17.4163C10.4948 17.4938 10.3667 17.5565 10.2349 17.6155V14.0194ZM5.47265 8.23974C5.46899 7.6533 5.80575 7.19594 6.48294 6.86768L6.61472 6.81604V9.72614C5.857 9.43476 5.47631 8.94053 5.47265 8.23974Z",
    fill: "#4E0AA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 24,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.44273e326c2770b4db1c0f949c3cb149.svg";
export { ForwardRef as ReactComponent };